import { PAGE_HEADER_HEIGHT, PAGE_HEADER_HEIGHT_EMPHASIZED } from '../../config'

export function getPageHeights(emphasizeHeader?: boolean) {
  const headerHeight = emphasizeHeader ? PAGE_HEADER_HEIGHT_EMPHASIZED : PAGE_HEADER_HEIGHT
  return { headerHeight }
}
